module.exports = __webpack_public_path__ + "img/banner-3-1@2x.72e31add.jpg";